/* eslint-disable import/prefer-default-export */
import { getPrimary as getPrimaryLanguage } from '../languages/index'

export const SORT_TYPE_POPULAR = 'popular'
export const SORT_TYPE_RECENT = 'recent'
export const SORT_TYPE_ALPHA = 'alpha'
export const SORT_TYPE_RECOMMENDED = 'recommended'

const SORT_OPTIONS = [
  SORT_TYPE_POPULAR,
  SORT_TYPE_RECENT,
  SORT_TYPE_ALPHA,
  SORT_TYPE_RECOMMENDED,
]

/**
 * Fetches sort options based on user language.
 * @param {Object} options The options
 * @param {import('immutable').List|String[]|String} options.language The requested language
 * @returns {Promise<Object>} A promise that resolves to an object with a `body`
 * property containing the sort options.
 */
export async function getFilterSortBy (options = {}) {
  const { language } = options
  const userLanguge = getPrimaryLanguage(language)
  let data = {}
  switch (userLanguge) {
    case 'es':
    case 'es-LA': {
      const result = await import('./lang_es-LA.json')
      data = result.default
      break
    }
    case 'de':
    case 'de-DE': {
      const result = await import('./lang_de-DE.json')
      data = result.default
      break
    }
    case 'fr':
    case 'fr-FR': {
      const result = await import('./lang_fr-FR.json')
      data = result.default
      break
    }
    case 'en':
    case 'en-US':
    default: {
      const result = await import('./lang_en.json')
      data = result.default
      break
    }
  }
  // Mimic and HTTP response shape putting the data on body
  const body = {
    facetValues: data.facetValues.map((item) => ({
      ...item,
      value: SORT_OPTIONS[item.value],
      path: null,
    })),
  }

  return { body }
}
